var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTextfieldCheckOn = function SvgIconTextfieldCheckOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z",
    fill: "#753BBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.286 11.6a.6.6 0 0 1-.435-.186l-2.285-2.4a.6.6 0 1 1 .868-.828l1.852 1.944 5.28-5.544a.6.6 0 0 1 .868.828l-5.714 6a.6.6 0 0 1-.434.186Z",
    fill: "#fff"
  })));
};
export default SvgIconTextfieldCheckOn;